// extracted by mini-css-extract-plugin
export default {"Data":"Data_Data__+nQCt","Calculation":"Data_Calculation__b+-zT","Piece":"Data_Piece__4f541","Message":"Data_Message__3X4iV"};